/* eslint-disable max-len */
import React from 'react';
import './style.css';
/* import './bootstrap.min.css'; */

function ReturnPolicy() {
    return (
        <div className='policy'>
            <nav className="relative flex flex-wrap items-center content-between py-3 px-4 top-0 ">
                <a href="https://www.adorwelding.com/" target="_blank" rel="noreferrer">
                    <img src="/images/Group8786.png" alt="icon" />
                </a>
            </nav>
            <div>
                <section className="sub-page-banner">
                    <div className='w-full flex items-center xl:flex-row flex-col lg:px-2 px-0'>
                        <img className="left" src="pattern-1.png" alt=""/>
                        <img className="right" src="/banner.png" alt=""/>
                    </div>
                </section>

                <section className="disclaimer-sec dpage">
                    <div className="container mx-auto sm:px-4">
                        <div className="flex flex-wrap ">
                            <div className="md:w-3/4 pr-4 pl-4 mx-auto">
                                <div className="about-disclaimer">
                                    <h3>REFUND AND CANCELLATION POLICY</h3>

                                    <div className="middleOpening">
                                        <div className="container mx-auto sm:px-4">
                                            <div className="accordinSection">
                                                <h4>ORDER MODIFICATION / CANCELLATION POLICY</h4>
                                                <p>Distributor will have the option to modify / edit the order till final acceptance by AWL. Order once accepted/cleared by AWL cannot be modified/edited/cancelled.</p>
                                                <h4>RETURN POLICY</h4>
                                                <p>In case of wrong delivery, Distributor should inform ASE and write to us at <a href="mailto:customerdesk@adorians.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-envelope-o" aria-hidden="true"></i>customerdesk@adorians.com</a> within 1 day of receipt of goods. We will arrange for
                                                    correct delivery and return pick up within 2 to 4 working days.</p>
                                                <p>In case of receipt of damaged goods, Distributor should immediately write to us at <a href="mailto:customerdesk@adorians.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-envelope-o" aria-hidden="true"></i>customerdesk@adorians.com</a> as per SOP for claiming Marine Insurance Credit note will be issued after completion of insurance claim process.</p>
                                                <h4>REFUNDS (IF APPLICABLE)</h4>
                                                <p>In case order processing is not completed after payment is done, we will process
                                                    your refund request within 5 to 7 working days. From the moment we refund you,
                                                    your bank still needs to process it. The amount of time this takes differs per bank and
                                                    payment method, but it takes approximately 14 days.</p>

                                            </div>
                                            <section className="clear"></section>
                                        </div>
                                    </div>
                                    <div className="clear"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div>
                <footer
                    className="text-center text-lg-start text-white"
                    style={{backgroundColor: "#45526e"}}
                >
                    <div className="container mx-auto sm:px-4 p-6 pb-0">
                        <section className="">
                            <div className="flex flex-wrap ">


                                <hr className="w-full clearfix md:hidden" />


                                <hr className="w-full clearfix md:hidden" />

                                <div className="md:w-1/4 pr-4 pl-4 lg:w-1/5 pr-4 pl-4 xl:w-1/5 pr-4 pl-4 mx-auto mt-3">

                                    <p>
                                        <a className="text-white" href="/terms-and-conditions">Terms & Conditions</a>
                                    </p>
                                    <p>
                                        <a className="text-white" href="/privacy-policy">Privacy Policy</a>
                                    </p>                                    <p>
                                        <a className="text-white" href="/return-policy">Refund And Cancellation Policy</a>
                                    </p>                                    <p>
                                        <a className="text-white" href="/shipping-policy">Shipping Policy</a>
                                    </p>                                    <p>
                                        <a className="text-white" href="/pricing-policy">Pricing Policy</a>
                                    </p>

                                </div>

                                <hr className="w-full clearfix md:hidden" />

                            </div>
                        </section>

                        <hr className="my-3" />

                        <section className="p-6 pt-0">

                        </section>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default ReturnPolicy;
